import { DataType, Struct, Type, Vector } from 'apache-arrow';

import { StageMapResponseRow } from '../../../../services/data/impl/wrangler/schemas/stageMapResponse';
import { GPSCoordinates, Point } from '../../../commonUI/maps/types';
import { useDuckQuery } from '../../../duckDB/hooks/useDuckQuery';
import { formattedDateColumn } from '../../../duckDB/utils/formattedDateColumn';

export const useGetBlockPoints = (
  blockId: string,
  scanId: string,
  isTableLoading: boolean
): { points: BlockPointData[] | null; loading: boolean } => {
  // NOTE: The map view uses the stage_raw_count column, which is the raw count of the stage.
  // The stage_count column represents an estimated count of the stage used by the reports page.
  const { data: points, isLoading } = useDuckQuery<BlockPointData>(
    `SELECT
        point_id as id,
        alley,
        block_id as blockId,
        block_name as blockName,
        left_camera_img_path as leftCameraImgPath,
        ranch_name as ranchName,
        row_id as rowId,
        rowside_id as rowsideId,
        scan_id as scanId,
        view_direction as viewDirection,
        gps,
        ${formattedDateColumn('scan_date')} AS scanDate,
        photographed_at AS photographedAt,
        list({'stageId': stage_id, 'count': round(stage_raw_count::FLOAT)}) AS stageCounts,
        round(sum(stage_raw_count::FLOAT)) AS stageTotalCount
    FROM stage_map_table 
    WHERE scan_id='${scanId}' 
      AND block_id='${blockId}'
    GROUP BY ALL
    ORDER BY photographedAt ASC`,
    isTableLoading || !blockId || !scanId
  );

  return {
    points: points || null,
    loading: isTableLoading || isLoading,
  };
};

export type BlockPointData = Point & {
  id: StageMapResponseRow['point_id'];
  alley: StageMapResponseRow['alley'];
  blockId: StageMapResponseRow['block_id'];
  blockName: StageMapResponseRow['block_name'];
  /**
   * NOTE/TODO: Follow up on why this is missing from the response from Wrangler
   */
  rightCameraImgPath: StageMapResponseRow['right_camera_img_path'];
  leftCameraImgPath: StageMapResponseRow['left_camera_img_path'];
  ranchName: StageMapResponseRow['ranch_name'];
  rowId: StageMapResponseRow['row_id'];
  rowsideId: StageMapResponseRow['rowside_id'];
  scanId: StageMapResponseRow['scan_id'];
  viewDirection: StageMapResponseRow['view_direction'];
  scanDate: StageMapResponseRow['scan_date'];
  photographedAt: string;
  stageTotalCount: number;
  stageCounts: Vector<
    Struct<{ stage_id: DataType<Type.Utf8>; count: DataType<Type.Float> }>
  >;
  gps: GPSCoordinates;
};
